import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CUSTOMER_TICKETING_FEATURE, CustomerTicketingRootModule } from '@spartacus/customer-ticketing/root';

@NgModule({
  declarations: [],
  imports: [CustomerTicketingRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CUSTOMER_TICKETING_FEATURE]: {
          module: () => import('@spartacus/customer-ticketing').then((m) => m.CustomerTicketingModule),
        },
      },
    }),
  ],
})
export class CustomerTicketingFeatureModule {}
